import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import api from '../config/api.js';

const DEFAULT_CREATED_AT = '2026-02-20';

const StartDatePrompt = () => {
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    api.get('/auth/me')
      .then(res => {
        const createdAt = res.data.created_at;
        if (createdAt) {
          const dateStr = new Date(createdAt).toISOString().split('T')[0];
          if (dateStr === DEFAULT_CREATED_AT) {
            setOpen(true);
          }
        }
        setChecked(true);
      })
      .catch(() => {
        setChecked(true);
      });
  }, []);

  const handleSave = async () => {
    if (!startDate) {
      setError('Please select your start date.');
      return;
    }

    try {
      setSaving(true);
      setError('');
      await api.patch('/auth/start-date', { start_date: startDate });
      setOpen(false);
    } catch (err) {
      setError('Failed to save start date. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  if (!checked || !open) return null;

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      }}
    >
      <DialogTitle>Welcome! Set Your Start Date</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Please enter the date you started with the company. This helps us
          track team retention and performance metrics accurately.
        </Typography>
        <TextField
          label="Start Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving || !startDate}
        >
          {saving ? <CircularProgress size={20} /> : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StartDatePrompt;
